import { AnyRequestLifecycleAction, RequestState } from '../types';

export * from './appCache';
export { combineReducers } from './combineReducers';
export * from './entities';
export * from './fetchStatus';
export { createAction } from './types';
export type { ActionType, ObjectValues, StateType } from './types';

export function getIsReady<T extends RequestState<any>>(requestState: T) {
  const { loading, error, lastRequested } = requestState;
  return !loading && !error && lastRequested > -1;
}

/**
 * Overrides a RequestLifecycleAction, setting the force equal to true.
 *
 * We specify `force: true` to ensure that react-query is driving the caching behavior, not redux.
 * react-query will store the query and mutation fn's return in its own cache, so we don't want to rely
 * on the redux cache as well. Doing so would make it impossible to clear the cache using
 * traditional react-query methods, like queryClient.invalidateQueries.
 *
 * @param action any RequestLifecycleAction
 * @returns the same action with force set to true
 */
export const toForcedRequestLifecycleAction = <R extends AnyRequestLifecycleAction>(
  action: R,
): R => ({
  ...action,
  request: {
    ...action.request,
    force: true,
  },
});
